import { queryOptions, useQuery } from "@tanstack/react-query";

import { baseInfo } from "./generated/admin";

export function baseInfoQueryOptions() {
  return queryOptions({
    queryKey: ["admin", "base-info"],
    queryFn: () => baseInfo(),
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
    retryOnMount: false,
    refetchOnReconnect: false,
  });
}

export function useBaseInfoCache() {
  const { data } = useQuery({ ...baseInfoQueryOptions(), enabled: false });
  return data;
}
